// extracted by mini-css-extract-plugin
export default {"pdfPreviewModal":"preview-pop-up_pdfPreviewModal__JR+X1"};